<template>
    <h1 class="title is-5">Not Delivered OR with Notes</h1>
    <base-spinner v-if="isLoading"></base-spinner>
    <div v-else class="block align-center">
        <h1 class="block title is-6" v-if="deliveries">Total deliveries found: {{ deliveries.length }}
        </h1>
        <button class="button is-rounded is-info block" @click="loadDeliveries">
            <span v-if="deliveries">Reload</span>
            <span v-else>Load</span>
        </button>
        <DeliveryItem v-for="delivery in deliveries" :key="delivery.beneficiary_id" :name="delivery.full_name"
            :dryBag="delivery.dry_bag" :quantity="delivery.quantity" :unit="delivery.unit" :block="delivery.block"
            :street="delivery.street" :completed="delivery.completed" :age="delivery.age"
            :deliverySort="delivery.delivery_sort" :beneficiaryID="delivery.beneficiary_id" :fdID="this.fdID"
            :fdStatus="this.fdStatus" :status="delivery.status" :selfCollection="delivery.self_collection"
            :drivingDelivery="delivery.driving_delivery" :deliveryNotes="delivery.notes" :bagStatus="delivery.bag_status"
            :consecutiveUndeliveredCount="delivery.consecutive_undelivered_count" :dietaryRequirement="delivery.dietary_requirement"
            :adminNotes="delivery.delivery_notes">
        </DeliveryItem>
    </div>
    <div v-if="!!error" class="notification is-danger is-light">
        <p><b>Something went wrong!</b></p>
        <p>{{ error }}</p>
    </div>
</template>

<script>
import DeliveryItem from './DeliveryItem.vue';

export default {
    components: {
        DeliveryItem
    },
    props: ['fdID', 'fdStatus'],
    data() {
        return {
            isLoading: false,
            error: ""
        }
    },
    methods: {
        async loadDeliveries() {
            this.isLoading = true;
            try {
                await this.$store.dispatch('delivery/loadDeliveriesWithNotes', this.fdID);
            } catch (error) {
                this.error = error.message;
            }
            this.isLoading = false;
        }
    },
    computed: {
        deliveries() {
            return this.$store.getters['delivery/getNotDeliveredDeliveries']
        }
    }
}
</script>